/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum IsoDayOfWeek {
    None = 'None',
    Monday = 'Monday',
    Tuesday = 'Tuesday',
    Wednesday = 'Wednesday',
    Thursday = 'Thursday',
    Friday = 'Friday',
    Saturday = 'Saturday',
    Sunday = 'Sunday'
}

export function IsoDayOfWeekFromJSON(json: any): IsoDayOfWeek {
    return IsoDayOfWeekFromJSONTyped(json, false);
}

export function IsoDayOfWeekFromJSONTyped(json: any, ignoreDiscriminator: boolean): IsoDayOfWeek {
    return json as IsoDayOfWeek;
}

export function IsoDayOfWeekToJSON(value?: IsoDayOfWeek | null): any {
    return value as any;
}

